// extracted by mini-css-extract-plugin
module.exports = {"highlight":"DealAlertHighlight-module__highlight___1dCrW","tooltipContent":"DealAlertHighlight-module__tooltipContent___7LcFX"};